const isDev = () =>
  process.env.CONTEXT === "dev" || process.env.NODE_ENV === "development"
exports.isDev = isDev

exports.getEnvKey = (devKey, prodKey) => {
  if (isDev()) return devKey
  else return prodKey
}
